import { render, staticRenderFns } from "./AnexosItem.vue?vue&type=template&id=57487324&"
import script from "./AnexosItem.vue?vue&type=script&lang=ts&"
export * from "./AnexosItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports